import React from 'react'
import ComingSoon from '../Common/ComingSoon'

const ConferenceHighlights = () => {
  return (
    <ComingSoon ></ComingSoon>
  )
}

export default ConferenceHighlights